import { Loader2, RefreshCw } from 'lucide-react'

interface RefreshButtonProps {
    isLoading: boolean
    onClick: () => void
    disabled?: boolean
}

function RefreshButton({ isLoading, onClick, disabled = false }: RefreshButtonProps) {
    if (disabled) {
        return <RefreshCw className='text-mach-accent-foreground h-5 w-5 cursor-not-allowed opacity-50' />
    }

    if (isLoading) {
        return <Loader2 className='text-mach-accent-foreground h-5 w-5 animate-spin' />
    }

    return (
        <RefreshCw
            className='text-mach-accent-foreground h-5 w-5 cursor-pointer transition-all hover:text-white'
            onClick={onClick}
        />
    )
}

export default RefreshButton
